import { Box, Chip, Divider, LinearProgress, Link, Stack, Typography } from "@mui/material";
import { PaperBox } from "../../../../components/Layout/PaperBox";
import { formatarCPFCNPJ, formatarValorMonetario } from "../../../../helpers/masks";
import PersonIcon from '@mui/icons-material/Person';
import { useMemo } from "react";
import { CardProps } from ".";

export default function CardResumo({
    data,
    handleOpenDetalheLimiteUtilizado
}: PropsCardResumo) {

    const porcentagemUtilizada = useMemo(() => {
        if (!data.limite_utilizado || !data.limite_disponivel) return 0;

        return Math.min(
            (Number(data.limite_utilizado) / (Number(data.limite_utilizado) + Number(data.limite_disponivel))) * 100,
            100
        )
    }, [data.limite_utilizado, data.limite_disponivel]);

    return (
        <PaperBox>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Typography variant="body1">
                    {`${data.nome_pessoa}`}
                </Typography>

                <Chip icon={<PersonIcon fontSize="small" />} label={`${data.tipo_publico}${data.codigo_publico}`} />
            </Stack>

            <Typography variant="subtitle2">
                <b>{data.documento_pessoa?.length === 11 ? 'CPF:' : 'CNPJ:'}</b> {formatarCPFCNPJ(data.documento_pessoa)}
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Stack>
                <Typography variant="subtitle1" fontWeight="medium">
                    Limite de crédito
                </Typography>

                <LinearProgress
                    variant="determinate"
                    color={porcentagemUtilizada === 100 ? 'error' : 'success'}
                    value={porcentagemUtilizada}
                    sx={{
                        height: 6,
                        borderRadius: 0.5
                    }}
                />

                <Stack direction="row" justifyContent="space-between" mt={1}>
                    <Box>
                        <Typography variant="body2" color="text.secondary">
                            Utilizado
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="medium">
                            {formatarValorMonetario(data.limite_utilizado ?? 0)}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="text.secondary" align="right">
                            Disponível
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="medium">
                            {formatarValorMonetario(data.limite_disponivel ?? 0)}
                        </Typography>
                    </Box>
                </Stack>
                <Link mt={1} onClick={handleOpenDetalheLimiteUtilizado} sx={{ cursor: 'pointer' }}>Ver detalhes</Link>
            </Stack>
        </PaperBox>
    )
}

interface PropsCardResumo extends CardProps {
    handleOpenDetalheLimiteUtilizado: VoidFunction
}
